import { useTranslation } from "react-i18next";

export default function TreescoutCrumb(): string {
  const { t } = useTranslation();
  return t("menu.Treescout");
}
